import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function Widget({ icon: Icon, title, action, to, toLabel = "Voir tout", testid, className = "", bodyClass = "p-5", children }) {
  return (
    <section data-testid={testid} className={`flex flex-col overflow-hidden rounded-2xl border border-zinc-800 bg-zinc-900 ${className}`}>
      <header className="flex items-center gap-3 border-b border-zinc-800/80 px-5 py-3.5">
        <h2 className="flex min-w-0 flex-1 items-center gap-2 truncate text-sm font-semibold text-white">
          {Icon && <Icon className="h-4 w-4 shrink-0 text-zinc-400" strokeWidth={1.8} />}{title}
        </h2>
        {action}
        {to && (
          <Link to={to} data-testid={testid ? `${testid}-link` : undefined} title={toLabel}
            className="group flex items-center gap-1 rounded-lg border border-zinc-800 px-2.5 py-1 text-xs text-zinc-400 transition-colors hover:border-[#FF6A00]/50 hover:text-white">
            {toLabel}<ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </Link>
        )}
      </header>
      <div className={`flex-1 ${bodyClass}`}>{children}</div>
    </section>
  );
}

export function KpiStrip({ items, testid }) {
  const cols = { 2: "grid-cols-2", 3: "grid-cols-3", 4: "grid-cols-2 lg:grid-cols-4" }[items.length] || "grid-cols-2 lg:grid-cols-4";
  return (
    <div data-testid={testid} className={`grid gap-px overflow-hidden rounded-2xl border border-zinc-800 bg-zinc-800 ${cols}`}>
      {items.map(({ icon: Icon, label, value, tint = "#FF6A00", onClick, testid: t, active }) => {
        const Tag = onClick ? "button" : "div";
        return (
          <Tag key={label} data-testid={t} onClick={onClick}
            className={`flex min-w-0 flex-col gap-2 bg-zinc-900 p-3 text-left transition-colors sm:flex-row sm:items-center sm:gap-3 sm:p-5 ${onClick ? "hover:bg-zinc-800/60" : ""} ${active ? "!bg-[#FF6A00]/[0.06]" : ""}`}>
            {Icon && <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl" style={{ background: `${tint}1a`, color: tint }}><Icon className="h-4 w-4" /></span>}
            <span className="min-w-0">
              <span className="block truncate text-xs text-zinc-500">{label}</span>
              <span className="block font-display text-lg font-bold text-white sm:text-xl">{value}</span>
            </span>
          </Tag>
        );
      })}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div data-testid={testid} className="flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        <h1 className="font-display text-3xl font-bold text-white sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-zinc-500">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
